export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";